import styled from 'styled-components';
import { Badge, Card, ListGroupItem } from 'reactstrap';

export const StyledRefreshButton = styled.button`
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 16px;
`;


export const StyledRefreshIcon = styled.i.attrs(() => ({
    className: 'icon-refresh fa-spin-custom ',
}))`
 color: #fff;
  font-size: 1.2em;
`;

export const StyledList = styled.ul.attrs(() => ({
    className: 'timeline'
}))``

export const StyledHeader = styled.div.attrs(() => ({
    className: 'd-flex justify-content-center'
}))``

export const StyledCard = styled(Card).attrs(() => ({
    className: 'border-0 shadow  card-timeline'
}))``

export const StyledBadge = styled(Badge).attrs(() => ({
    color: "primary.subtle", pill: true
}))`font-family: "Verdana";
font-size: 0.9em;
color: #27ade4;
background: rgba(109, 186, 218, 0.52);
padding-top: 7px;`

export const StyledListGroupItem = styled(ListGroupItem).attrs(() => ({
    className: 'px-0 d-flex justify-content-between align-items-start'
}))``


export const ItemStyledCard = styled(Card).attrs(() => ({
    className: 'border-0 shadow mb-0'
}))``


export const RestChildICon = styled.i.attrs(() => ({
    className: 'icon-rest-child',
}))`
 margin: -11px;
  font-size: 3em;
`;


export const TimeLineDiv = styled.div.attrs(() => ({
    className: 'timeline-badge  ',
}))`
 background-color: #47aee4 !important;
  z-Index: 0;
`;

export const StyledThumbImage = styled.img.attrs(() => ({
  alt: "Fp_Linkthumb",
}))`
  width: 100%;
  height: 100%;
  object-fit: fill;
`;
export const StyledThumbImage2 = styled.img.attrs(() => ({
  alt: "Fp_Linkthumb",
}))`
  width: 35px;
  height: 35px;
  object-fit: fill;
`;